import { render } from "./CompanyPage.vue?vue&type=template&id=212722a4&scoped=true"
import script from "./CompanyPage.vue?vue&type=script&lang=js"
export * from "./CompanyPage.vue?vue&type=script&lang=js"

import "./CompanyPage.vue?vue&type=style&index=0&id=212722a4&lang=css"
import "./CompanyPage.vue?vue&type=style&index=1&id=212722a4&scoped=true&lang=css"

import exportComponent from "F:\\MyCode\\ZSTek.SpecialEquipment\\ZSTek.SE.Screen.Web.Backstage\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-212722a4"]])

export default __exports__